import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

// Custom Triple Toggle Switch Component to show 3 states in a switch
const TripleToggleSwitch = ({
  value = -1,
  handleToggleChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const firedRef = useRef(false);
  const [currentState, setCurrentState] = useState(Number(value));

  //To set the value of currentState only once after having the values for same
  useEffect(() => {
    if (firedRef.current || value === -1) return;
    firedRef.current = true;
    setCurrentState(Number(value));
  }, [value]);

  //to handle the toggle state change
  const handleToggle = event => {
    const value = Number(event.target.value);
    handleToggleChange(value);
    setCurrentState(value);
  };

  return (
    <div className={`toggle-switch ${disabled ? 'disabled' : ''}`}>
      <input
        type="range"
        value={currentState}
        min={0}
        max={2}
        onChange={handleToggle}
      />
      <div className="selected-value">
        {currentState === 1
          ? t('Partial')
          : currentState === 2
            ? t('Yes')
            : t('No')}
      </div>
    </div>
  );
};

export default TripleToggleSwitch;
